import { validator } from "@/utils/validator";
import { ACCEPT_FILE_TYPES } from "@/features/company/constants/contractFile";

export const useContractFileSchema = () => {

  const contractFileSchema = validator
    .mixed<File>()
    .required();

  return { contractFileSchema, ACCEPT_FILE_TYPES };
};
